import config from "../config";
import { StatusCodes } from "http-status-codes";

/**
 * Base API client for making requests to the backend
 */
class ApiClient {
  constructor(baseURL) {
    this.baseURL = baseURL;
  }

  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;

    try {
      const response = await fetch(url, {
        ...options,
        headers: {
          "Content-Type": "application/json",
          ...options.headers,
        },
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({
          message: response.statusText,
        }));
        console.error(
          "API Error:",
          {
            url,
            status: response.status,
            statusText: response.statusText,
            message: error.message,
          }
        );

        // Check if it's an auth error
        if (
          response.status === StatusCodes.UNAUTHORIZED ||
          response.status === StatusCodes.FORBIDDEN
        ) {
          window.location.href = `/error?code=${
            response.status
          }&message=${encodeURIComponent(
            error.message || response.statusText
          )}`;
        }

        throw new Error(error.message || `API Error: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error("API request failed:", { url, error });

      // Check if it's a network error (API unreachable)
      if (error.message === "Failed to fetch" || error.name === "TypeError") {
        window.location.href = `/error?code=${
          StatusCodes.SERVICE_UNAVAILABLE
        }&message=${encodeURIComponent(
          "Unable to reach the server. Please check your connection and try again."
        )}`;
      }

      throw error;
    }
  }

  async get(endpoint, options = {}) {
    return this.request(endpoint, {
      ...options,
      method: "GET",
    });
  }

  async post(endpoint, data, options = {}) {
    return this.request(endpoint, {
      ...options,
      method: "POST",
      body: JSON.stringify(data),
    });
  }
}

// Export configured client instances
export const apiClient = new ApiClient(config.apiUrl);
export const phishinClient = new ApiClient(config.phishinApiUrl);

export default apiClient;
